// Global Instructions Rule Applied!

/**
 * Marker class on a column's card container; the drag auto-scroll looks for
 * it under the pointer. Deliberately not the shared `kanban-scrollbar`
 * styling class, which cards also use for their own small scroll areas.
 */
export const KANBAN_COLUMN_SCROLL_CLASS = 'kanban-column-scroll'
/** Distance from an edge, in px, within which dragging starts to scroll. */
export const AUTO_SCROLL_EDGE = 100
/** Scroll per tick, in px, when the pointer is on the edge itself. */
export const AUTO_SCROLL_MAX_STEP = 50
/** Interval between scroll ticks (~60fps). */
export const AUTO_SCROLL_TICK_MS = 16

/**
 * Scroll step for one tick while a card is dragged near the start or end of a
 * scrollable extent (a column's top/bottom, or the board's left/right).
 *
 * The step ramps linearly from 0 at the threshold to `maxStep` on the edge,
 * negative towards the start. It is 0 when the pointer is in the middle or
 * the container cannot scroll any further that way.
 */
export function edgeScrollStep(
  pointer: number,
  start: number,
  end: number,
  scrollPosition: number,
  scrollMax: number,
  edge = AUTO_SCROLL_EDGE,
  maxStep = AUTO_SCROLL_MAX_STEP
): number {
  if (pointer < start + edge && scrollPosition > 0) {
    const distance = Math.min(start + edge - pointer, edge)
    return -(distance / edge) * maxStep
  }
  if (pointer > end - edge && scrollPosition < scrollMax) {
    const distance = Math.min(pointer - (end - edge), edge)
    return (distance / edge) * maxStep
  }
  return 0
}
